import React, { useState, useEffect } from "react";
import axios from "axios";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
import "../../../../components/common/css/add.scss";
import PageShell from "../../../../components/layout/PageShell";
import PageHead from "../../../../components/layout/PageHead";

const SocialView = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const fetchlinksdata = () => {
    setLoading(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-social-media-links",
    };

    axios(config)
      .then(function (response) {
        setData(response?.data?.data[0]);
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchlinksdata();
  }, []);

  return (
    <PageShell><PageHead title="Social link view" /><div className="new">
      <div className="newContainer">
        <Loader isLoading={loading} />
        {data && (
          <div className="bottom">
            <div className="modal-content">
              <div className="modal-content-title">View Social Links</div>
              <p>&nbsp;</p>
              <form>
                <div className="custome-form-group">
                  <label>Facebook</label>
                  <input
                    type="text"
                    name="name"
                    value={data?.facebook_link}
                    disabled={true}
                    placeholder="Enter Category Name"
                    className="custome-input"
                  />
                </div>

                <div className="custome-form-group">
                  <label>Instagram</label>
                  <input
                    type="text"
                    name="title"
                    value={data?.instagram_link}
                    placeholder="Enter Category Title"
                    disabled={true}
                    className="custome-input"
                  />
                </div>
                <div className="custome-form-group">
                  <label>Linkedin</label>
                  <input
                    type="text"
                    name="name"
                    value={data?.linkedin_link}
                    disabled={true}
                    placeholder="Enter Category Name"
                    className="custome-input"
                  />
                </div>
                <div className="custome-form-group">
                  <label>Gmail</label>
                  <input
                    type="text"
                    name="name"
                    value={data?.gmail_link}
                    disabled={true}
                    placeholder="Enter Category Name"
                    className="custome-input"
                  />
                </div>
                <div className="custome-form-group">
                  <label>Twitter</label>
                  <input
                    type="text"
                    name="name"
                    value={data?.twitter_link}
                    disabled={true}
                    placeholder="Enter Category Name"
                    className="custome-input"
                  />
                </div>
                <button type="submit" className="approveButton" disabled={true}>
                  Save
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div></PageShell>
  );
};

export default SocialView;
